import { createContext, useContext } from 'react'
import { castArray, map } from 'lodash'

import IFilterParams from './types/IFilterParams'
import IUser from './types/IUser'
import {
  OrganisationRoleEnum,
  UserModelAsAdminQueriesFilterInput
} from 'front-end/src/graphql/private/PrivateSchemaTypes'

export type TargetUserIds = number | number[]

export const eachTargetId = async (
  target: TargetUserIds,
  cb: (userId: number) => Promise<any>
): Promise<void> => {
  const userIds = castArray(target)
  const promises = map(userIds, cb)
  await Promise.all(promises)
}

export type ManageUsersPageContextType = {
  filter: IFilterParams
  users: IUser[]
  usersCount: number
  selectedUserIds: number[]
  page: number
  loading: boolean
  showCreateUserModal: boolean
  onFilterChange?: (filter: Partial<IFilterParams>) => void
  onPageChange?: (page: number) => void
  filterAsDescriptors: (
    isExport: boolean
  ) => UserModelAsAdminQueriesFilterInput[]
  onAddToGroup?: (options: {
    target: TargetUserIds
    groupId?: number
    groupName?: string
  }) => void
  onRemoveFromGroup?: (options: {
    target: TargetUserIds
    groupId: number
  }) => void
  onRemoveUser?: (options: { target: TargetUserIds }) => void
  onRoleChange?: (options: {
    target: TargetUserIds
    role: OrganisationRoleEnum
  }) => void
  toggleUserSelection?: (options: { userId: number; value: boolean }) => void
  toggleAllUsersSelection?: (options: { value: boolean }) => void
  fetchUsers?: () => void
  onExport?: () => void
}

export const getDefaultContext = (): ManageUsersPageContextType => ({
  filterAsDescriptors: () => [],
  users: [],
  usersCount: 0,
  selectedUserIds: [],
  page: 1,
  filter: {
    role: '',
    search: '',
    groupId: '',
    showArchived: false
  },
  loading: false,
  showCreateUserModal: false
})

export const ManageUsersPageContext = createContext<ManageUsersPageContextType>(
  getDefaultContext()
)

export const useManageUsersPageContext = () =>
  useContext(ManageUsersPageContext)
